export type ViewType = 'board' | 'list'

const KEY = 'admination.azav.viewType.coachings'

export function getViewType(): ViewType {
  const stored = localStorage.getItem(KEY)
  return stored === 'list' ? 'list' : 'board'
}

export function setViewType(type: ViewType): void {
  localStorage.setItem(KEY, type)
}
